import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Section } from '@shared/components/section'

import { Tab2012 } from './tabs/2012'
import { Tab2017 } from './tabs/2017'
import { Tab2018 } from './tabs/2018'
import { Tab2019 } from './tabs/2019'
import { Tab2020 } from './tabs/2020'
import { Tab2021 } from './tabs/2021'
import { Tab2022 } from './tabs/2022'
import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<Section className={styles.longHistory}>
			<h2 className={styles.heading}>{data.heading}</h2>
			<Tabs selectedTabClassName={styles.activeTab}>
				<TabList className={styles.tabsList}>
					<Tab className={styles.tab}>2012</Tab>
					<Tab className={styles.tab}>2017</Tab>
					<Tab className={styles.tab}>2018</Tab>
					<Tab className={styles.tab}>2019</Tab>
					<Tab className={styles.tab}>2020</Tab>
					<Tab className={styles.tab}>2021</Tab>
					<Tab className={styles.tab}>2022</Tab>
				</TabList>

				<TabPanel>
					<Tab2012 />
				</TabPanel>
				<TabPanel>
					<Tab2017 />
				</TabPanel>
				<TabPanel>
					<Tab2018 />
				</TabPanel>
				<TabPanel>
					<Tab2019 />
				</TabPanel>
				<TabPanel>
					<Tab2020 />
				</TabPanel>
				<TabPanel>
					<Tab2021 />
				</TabPanel>
				<TabPanel>
					<Tab2022 />
				</TabPanel>
			</Tabs>
		</Section>
	)
}
